import React from 'react';
import { RadioGroup as RadioGroupNew } from './RadioGroup';
import { convertOldRadioGroupProps } from './converter.old';
import type { OldRadioGroupProps, RadioItemType } from './converter.old';
import type { RadioGroupInstance, RadioGroupVariant } from './RadioGroup';
import type { BoxRadioSizeUnion, DefaultRadioSizeUnion } from './types';

export type { RadioItemType } from './converter.old';
export type { AlignType, RadioItem, RadioWidthType } from './RadioGroup';

export interface RadioCategoryType<T extends RadioItemType> {
  radioItemType?: T;
  size?: T extends 'box' ? BoxRadioSizeUnion : DefaultRadioSizeUnion;
}

export type RadioGroupProps<RadioValue> = OldRadioGroupProps<RadioValue>;

function RadioGroupInner<RadioValue>(
  props: RadioGroupProps<RadioValue>,
  ref: React.Ref<RadioGroupInstance<RadioValue>>,
) {
  return <RadioGroupNew {...convertOldRadioGroupProps(props)} ref={ref} />;
}

export const RadioGroup = React.forwardRef(RadioGroupInner) as <RadioValue>(
  props: RadioGroupProps<RadioValue> & { ref?: React.Ref<RadioGroupInstance<RadioValue>> },
) => React.ReactElement;

export type { RadioGroupVariant };
